import { useMemo, useRef } from 'react';
import { useLocale, useTranslation } from '@aviv-unified-frontend/runtime/i18n';
export const useLoadTranslations = (namespace, translations) => {
    const { language } = useLocale();
    const { addTranslations } = useTranslation(namespace);
    const removeTranslations = useRef(() => { });
    removeTranslations.current = useMemo(() => {
        const loadTranslations = async () => {
            return addTranslations({
                language,
                translations: getTranslationsByLocale(translations, language),
            });
        };
        loadTranslations();
        return () => {
            // Cleanup function if needed
        };
    }, [addTranslations, language, translations]);
};
const getTranslationsByLocale = (translations, language) => {
    const translationByLocale = translations[language];
    if (!translationByLocale) {
        throw new Error('No translations found for the given locale');
    }
    return translationByLocale;
};
